import React from "react";
import {
  Card, CardHeader, CardContent, TextField,
  Typography, Grid, IconButton, Button, Divider
} from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { useTranslation } from "react-i18next";

export default function DescriptionTechSection({
  formData,
  handleText,
  setArrayItem,
  addArrayItem,
  removeArrayItem,
}) {
  const { t } = useTranslation("products");
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={t("form.descriptionTechTitle")}
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <TextField
          label={t("form.descriptionLabel")}
          name="detalhes"
          value={formData.detalhes}
          onChange={handleText}
          fullWidth
          multiline
          minRows={3}
          placeholder={t("form.descriptionPlaceholder")}
          sx={{ mb: 2 }}
        />

        <Typography variant="subtitle2" sx={{ mb: 1 }}>{t("form.featureListTitle")}</Typography>
        {(formData.caracteristicas || []).map((item, idx) => (
          <Grid container spacing={1} alignItems="center" key={`car-${idx}`} sx={{ mb: 1 }}>
            <Grid item xs>
              <TextField
                fullWidth
                placeholder={t("form.featurePlaceholder")}
                value={item || ""}
                onChange={(e) => setArrayItem("caracteristicas", idx, e.target.value)}
              />
            </Grid>
            <Grid item>
              <IconButton onClick={() => removeArrayItem("caracteristicas", idx)}>
                <DeleteOutlineRoundedIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        ))}
        <Button size="small" variant="outlined" onClick={() => addArrayItem("caracteristicas", "")}>
          {t("form.addFeature")}
        </Button>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle2" sx={{ mb: 1 }}>{t("form.specsTitle")}</Typography>
        {(formData.ficha_tecnica || []).map((par, idx) => (
          <Grid container spacing={1} alignItems="center" key={`ft-${idx}`} sx={{ mb: 1 }}>
            <Grid item xs={12} sm={5}>
              <TextField
                fullWidth
                placeholder={t("form.specKeyPlaceholder")}
                value={par?.chave || ""}
                onChange={(e) => {
                  const next = { ...(par || {}), chave: e.target.value };
                  setArrayItem("ficha_tecnica", idx, next);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                placeholder={t("form.specValuePlaceholder")}
                value={par?.valor || ""}
                onChange={(e) => {
                  const next = { ...(par || {}), valor: e.target.value };
                  setArrayItem("ficha_tecnica", idx, next);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={1}>
              <IconButton onClick={() => removeArrayItem("ficha_tecnica", idx)}>
                <DeleteOutlineRoundedIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        ))}
        <Button
          size="small"
          variant="outlined"
          onClick={() => addArrayItem("ficha_tecnica", { chave: "", valor: "" })}
        >
          {t("form.addSpecRow")}
        </Button>
      </CardContent>
    </Card>
  );
}
